export default __webpack_public_path__ + "navigation-examples-basic-thumbnail-v1-480-a89de0d54cc425148691f308e1af3198.png";